import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const ChevronDown: React.FC<IconProps> = ({
  className = '',
  fill = colors.blueGrey,
  viewBox = '0 0 13 8',
  d = 'M11.132 0L6.5 4.319 1.868 0 0 1.862 6.459 8 13 1.862z',
  transition = 'fill 0.1s ease-in-out',
  cssHelper = Styling.fullHeightStyle,
  width = 13,
  height = 8,
  focusable
}) => {
  return (
    <Elements.Svg
      viewBox={viewBox}
      className={cx({ [className]: !!className })}
      width={width}
      height={height}
      cssHelper={cssHelper}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.Path fill={fill} d={d} transition={transition} />
    </Elements.Svg>
  );
};

export default ChevronDown;
